import gql from 'graphql-tag'

export const GET_INVITATION_TEMPLATES = gql`
  query getInvitationTemplates {
    invitationTemplates {
      id
      name
      description
    }
  }
`

export const UPDATE_EVENT_INVITATION_TEMPLATE = gql`
  mutation updateEventInvitationTemplate(
    $eventId: ID!
    $input: EventInvitationTemplateInput!
  ) {
    updateEventInvitationTemplate(eventId: $eventId, input: $input) {
      result {
        id
        invitationTemplate {
          id
          template
        }
      }
      errors {
        key
        message
      }
    }
  }
`
